export default __webpack_public_path__ + "static/media/wa-photo.3d99f444.jpg";